









import Vue from "vue";
import BaseScreen from "@/components/templates/BaseScreen/index.vue";

export default Vue.extend({
  components: { BaseScreen },
  methods: {
    handleOnLogout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
});
